<template>

    <div class="synchronize-column">
        <div class="synchronize-button" :class="[synchronizationStatus, {'disabled': hasProcessingVideos}]" @click="synchronize">
            <div class="button-inner">{{ synchronizationButtonText }}</div>
        </div>
        <div class="disabled-hint" v-if="hasProcessingVideos">{{ t.__('Przetwarzanie wideo nadal w toku') }}</div>
        <div class="pending-hint" v-if="synchronizationStatus === 'pending'">{{ t.__('Urządzenie jest offline') }}</div>

        <div class="last-synchronization-date">
            <div class="title">{{ t.__('Ostatnia aktualizacja') }}:</div>
            <div class="value">{{ lastSynchronizationDate }}</div>
        </div>

        <div class="space-usage">
            <div class="title">{{ t.__('Zajęte miejsce') }}:</div>
            <div class="value">{{ usedDiskSpace }}MB / {{ totalDiskSpace }}MB</div>
        </div>
    </div>

</template>

<script>

export default {

    name: 'SynchronizationColumn',

    data() {
        return {
            eventHub: window.eventHub,
            synchronizationStatus: 'synchronized', // synchronized, pending, synchronizing, unsynchronized,
            lastSynchronizationDate: '---',
            totalDiskSpace: 0,
            usedDiskSpace: 0,
            hasProcessingVideos: false
        }
    },

    computed: {
        synchronizationButtonText() {
            switch (this.synchronizationStatus) {
                case 'synchronized':
                    return t.__('Urządzenie zaktualizowane');
                case 'pending':
                    return t.__('Oczekiwanie na synchronizację');
                case 'synchronizing':
                    return t.__('W trakcie aktualizacji');
                case 'unsynchronized':
                    return t.__('Zaktualizuj zmiany na urządzeniu');
                default:
                    return ''
            }
        },
        // freeDiskSpace() {
        //     return Math.round(((this.totalDiskSpace - this.usedDiskSpace) + Number.EPSILON) * 100) / 100;
        // }
    },

    beforeMount() {

        this.getSynchronizationDetails();

    },

    mounted: function () {

        this.eventHub.$on('machine-synchronization-set-status-unsynchronized', () => {
            this.synchronizationStatus = 'unsynchronized';
        });

        window.setInterval(() => {
            if (this.hasProcessingVideos || this.synchronizationStatus === 'synchronizing') {
                this.getSynchronizationDetails();
            }
        }, 2000);

    },

    beforeDestroy: function () {

    },

    methods: {

        getSynchronizationDetails() {
            axios.get('/machine/get-synchronization-details')
                .then(response => {
                    this.synchronizationStatus = response.data.synchronization_status;
                    this.lastSynchronizationDate = response.data.last_synchronization_date;
                    this.totalDiskSpace = response.data.total_disk_space;
                    this.usedDiskSpace = response.data.used_disk_space;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        synchronize() {
            if (this.hasProcessingVideos || this.synchronizationStatus === 'synchronized' || this.synchronizationStatus === 'synchronizing') {
                return;
            }

            axios.post('/machine/synchronize')
                .then(response => {
                    console.log(response);
                    this.eventHub.$emit('machine-synchronization-started');
                    this.synchronizationStatus = 'synchronizing';
                })
                .catch(error => {
                    console.log(error);
                    alert(t.__('Wystąpił błąd synchronizacji'))
                });
        }

    }

}
</script>

<style scoped>

</style>
